import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import { Box, Modal, Tooltip } from "@mui/material";
import React, { useState } from "react";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  height: "99%",
  bgcolor: "background.paper",
  borderRadius: 2,
  overflowY: "auto",
  border: "none",
  "&:focus": {
    outline: "none",
  },
};

function IncidentReportViewer({ images, onClose, initialIndex, open }) {
  const [selectedImageIndex, setSelectedImageIndex] = useState(initialIndex);

  const handleNextImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex < images.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  const handlePrevImage = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : prevIndex
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      onClose();
    }
  };

  console.log("images321", images);

  console.log(images?.length > 0, selectedImageIndex);

  console.log("Viewing:", {
    selectedImageIndex,
  });

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={ModalStyle} className="max-h-[88%] xl:max-h-[100%]">
        <CancelPresentationIconButton
          onClick={() => {
            onClose();
          }}
        />
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 flex items-center justify-center z-1500"
          onKeyDown={handleKeyDown}
          tabIndex="0"
        >
          <div className="max-w-full max-h-full relative overflow-y-auto">
            <div className="fixed z-50 top-[2px] right-[2px]  cursor-pointer">
              <CancelPresentationIconButton onClick={onClose} />
            </div>

            {/* <img
              src={images[selectedImageIndex]}
              alt={`Image ${selectedImageIndex + 1}`}
              className="w-full h-full object-contain"
            /> */}
            {(() => {
              const currentFile = images[selectedImageIndex];
              const base64Content = currentFile.split(",")[1] || "";

              if (
                base64Content.startsWith("iVBORw0KGgo") ||
                base64Content.startsWith("/9j/")
              ) {
                return (
                  <img
                    key={selectedImageIndex}
                    src={currentFile}
                    alt={`Image ${selectedImageIndex + 1}`}
                    className="object-contain"
                    style={{ height: "90vh", width: "90vw", border: "none" }}
                  />
                );
              } else if (base64Content.startsWith("JVBERi0")) {
                return (
                  <iframe
                    key={selectedImageIndex}
                    src={`data:application/pdf;base64,${base64Content}`}
                    title={`PDF ${selectedImageIndex + 1}`}
                    className="w-full h-full"
                    style={{ height: "90vh", width: "90vw", border: "none" }}
                  />
                );
              } else if (
                base64Content.startsWith("UEsDB") ||
                base64Content.startsWith("0M8R4KGxGuE")
              ) {
                let fileFormat = null;
                if (base64Content.startsWith("UEsDB")) {
                  fileFormat = "doc";
                } else if (base64Content.startsWith("0M8R4KGxGuE")) {
                  fileFormat = "xlsx";
                }
                return (
                  <div className="text-white text-center text-lg p-4">
                    ⚠️ Preview not available for DOCX/XLSX.
                    <br />
                    <a
                      href={currentFile}
                      key={selectedImageIndex}
                      download={`file-${selectedImageIndex + 1}.${fileFormat}`}
                      className="text-blue-400 underline mt-2 inline-block"
                    >
                      Download File
                    </a>
                  </div>
                );
              } else {
                // Unknown format
                return (
                  <div className="text-white text-center text-lg p-4">
                    ❌ Unknown or unsupported file format.
                    <br />
                    {/* <a
                      href={currentFile}
                      key={selectedImageIndex}
                      download={`file-${selectedImageIndex + 1}`}
                      className="text-blue-400 underline mt-2 inline-block"
                    >
                      Download File
                    </a> */}
                  </div>
                );
              }
            })()}

            <images />
            <div className="fixed bottom-4 left-0 w-full flex justify-end p-10 space-x-2 ">
              {images?.length > 0 && selectedImageIndex > 0 && (
                <button
                  onClick={handlePrevImage}
                  className="btn-nav border rounded-full bg-customBlue text-white"
                >
                  <Tooltip title={"Previous"}>
                    <KeyboardArrowLeftOutlinedIcon
                      style={{
                        fontSize: "40px",
                        width: "40px",
                        height: "40px",
                      }}
                    />
                  </Tooltip>
                </button>
              )}

              {images?.length !== selectedImageIndex + 1 && (
                <button
                  onClick={handleNextImage}
                  className="btn-nav border rounded-full bg-customBlue text-white"
                >
                  <Tooltip title={"Next"}>
                    <ChevronRightOutlinedIcon
                      style={{
                        fontSize: "40px",
                        width: "40px",
                        height: "40px",
                      }}
                    />
                  </Tooltip>
                </button>
              )}
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default IncidentReportViewer;
